import { PlayerManagerProps as Props } from '../../../../../shared/types/props/player';
import { PlayerState } from '../../../../../shared/types/enums/player';
import { mediaSelector } from '../../../../../shared/store/slices/media.slice';
import { useAppSelector } from '../../../../../shared/store/hooks';
import { useEffect } from 'react';

const MILLISECONDS_TO_SECONDS = 1000;

function MediaManager({ dash: player, video }: Props) {
  const { position, state } = useAppSelector(mediaSelector);

  useEffect(() => {
    if (player) {
      switch (state) {
        case PlayerState.PAUSE:
          try {
            player.pause();
          } catch (error) {
            console.error('[Dash][Media manager] Pause');
          }
          break;

        case PlayerState.PLAY:
        case PlayerState.SEEKING:
          try {
            player.play();
          } catch (error) {
            console.error('[Dash][Media manager] Play');
          }
          break;

        case PlayerState.SEEK:
          try {
            if (player.isDynamic()) {
              const livePosition =
                player.getDVRWindowSize() +
                Math.round((position - Date.now()) / MILLISECONDS_TO_SECONDS);
              player.seek(livePosition);
            } else {
              player.seek(position);
            }
          } catch (error) {
            console.error('[Dash][Media manager] Seek');
          }
          break;

        default:
          break;
      }
    }
  }, [player, position, state, video]);

  return null;
}

export default MediaManager;
